import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { Button, Row, Text } from 'Components/UI'

import { BackgroundImage } from 'Assets/Images/Sections/ContactUs'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { Container, Content, Overflow } from './styles'

type Props = PaddingProps & {
  onAction?: () => void
}

function ContactUsSection({ onAction, ...rest }: Props) {
  return (
    <SectionContainer {...rest} px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Container>
          <Content>
            <Image alt="" src={BackgroundImage} />

            <Overflow />

            <Text bold center inverse mb={8} screen28 width="80%">
              Would like to learn more? We’re here to help.
            </Text>

            <Row fullWidth justifyCenter mt={5}>
              <Button large onClick={onAction}>
                Contact Us
              </Button>
            </Row>
          </Content>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default ContactUsSection
